
export const ServiceType = {
  GENERAL_SERVICE: {value: "General Service", key: "GENERAL_SERVICE"},
  SPECIAL_SERVICE: {value: "Special Service", key: "SPECIAL_SERVICE"},
} as const;
export type ServiceType = typeof ServiceType[keyof typeof ServiceType];

